
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {
    achievementSchemas,
    achievementUnknownBadgeImage,
    badgeSchemas,
} from '@/entities/scorecard'

@Component<ScorecardBadge>({})
export default class ScorecardBadge extends Vue {
    @Prop(String) public label!: string
    @Prop(String) public countUnseen!: string
    @Prop(String) public count!: string
    @Prop(String) public badgeId!: string
    @Prop(String) public badgeType!: string
    // whether show unread count number or just a red dot
    @Prop({ type: Boolean, default: true }) public showCount!: boolean

    @Prop({ type: Boolean, required: false })
    noSpace?: boolean

    public get badgeSchema() {
        return (
            badgeSchemas[this.badgeId] ?? achievementSchemas[this.badgeId] ?? {}
        )
    }

    public get countStyle() {
        const { foreColor, color } = this.badgeSchema
        return `background-color: ${foreColor}; color: ${color}`
    }

    public get badgeImage() {
        if (this.badgeType === 'achievement' && Number(this.count) < 1) {
            return achievementUnknownBadgeImage
        } else {
            return this.badgeSchema.img
        }
    }
}
